import Sign from "../../models/Sign"
import { Loading } from "../Misc/Loading"
import { ErrorView } from "../Misc/ErrorView"

interface SignsListProp {
    signs: Sign[] | null,
    inputValue: string,
    handleOpenModal: (data: Sign) => void,
    loading: boolean,
    error?: Error,
    notFoundMsg?: string,
}

export default function SignList (
    {signs, inputValue, handleOpenModal, loading, error, notFoundMsg = 'Aún no tenemos signos con ese nombre 🫤'}: SignsListProp
) {
    if (loading) {
        return <Loading />
    } else if (error) {
        return <ErrorView error={error} />
    } else if  ((!signs || signs.length === 0) && inputValue.length === 0) {
        return <p>🔍 Busca algún signo!</p>
    } else if ((!signs || signs.length === 0)) {
        return <p>{notFoundMsg}</p>
    } else {
        return <ul className="button-list">
            {signs?.map((sign, idx) => (
                <li key={idx}>
                    <button onClick={() => handleOpenModal(sign)}>
                        <div className="d-flex justify-content-space-between">
                            <div className="name capitalize">{sign['name']}</div>
                            {sign.level !== null && <div title="Dificultad">{'📘'.repeat(sign.level)}</div>}
                        </div>
                        <div className="mute truncate capitalize mr-2">{sign['definition']}</div>
                    </button>
                </li>
            ))}
        </ul>
    }
}